import { Injectable } from "@angular/core";
import { ClientService } from "./client.service";
import { MemberSiteVisitService } from "./memberSiteVisit.service";


//Read the Client Config table by using single or multiple keys
@Injectable()
export class ConfigService {     
    
    constructor(
        private clientService: ClientService,
        private memberSiteVisit: MemberSiteVisitService
    ) { }

    //Read the Client Config table by using single key
    public GetConfig(key):Promise<boolean>{
        return this.clientService.sessionStoreClientCode().toPromise()
            .then((data) => {               
                
                return this.memberSiteVisit.getConfig(key, data).toPromise()
                    .then((response: any) => {                        
                        return Promise.resolve(response);
                    });
            })
            .catch((error) => {                
                return Promise.reject();               
            });
    } 

    //Read the Client Config table by using multiple keys
    public GetConfigs(key):Promise<boolean>{
        return this.clientService.sessionStoreClientCode().toPromise()
            .then((data) => {               
                
                return this.memberSiteVisit.getConfigs(key, data).toPromise()
                    .then((response: any) => {                        
                        return Promise.resolve(response);
                    });
            })
            .catch((error) => {                
                return Promise.reject();               
            });
    }
}
